import { ISelectionParams } from "../../../Cryptography/Crypto/Messages/MessagesInterface";

/**
 * Data transfer object s informacemi o profilu s nastavením provideru pro podpisy
 * @includeToDoc
 */
export interface ISignatureProviderProfile {
    /**
     * Identifikátor profilu
     */
    id: string;

    /**
     * Informace o nastavení provideru pro podpisy
     */
    settings?: ISignatureProviderSettings;
}

/**
* Informace o nastavení provideru pro podpisy
* @includeToDoc
*/
export interface ISignatureProviderSettings extends ICounterSignatureProfile {
    /**
     * Identifikátor nastavení, nepovinný
     */
    id: string;

    /**
     * Typ provideru
     */
    providerType: string;

    /**
     * Verze provideru
     */
    providerVersion: string;

    /**
     * Značí, zda bude vytvořený podpis uvnitř podespaných dat
     */
    signatureInsideDocument: boolean;

    /**
     * Profil protipodpisu
     */
    counterSignatureProfile?: ICounterSignatureProfile;

    /** Objekt umožňující specifikovat parametry pro předvýběr/filtrování podpisového certifikátu */
    selectionParams?: ISelectionParams;
}

/**
* Informace o nastavení provideru pro protipodpisy
* @includeToDoc
*/
export interface ICounterSignatureProfile {
    /**
     * Ostatní parametry, které si parsuje daný provider
     */
    otherParams: any;

    /**
     * Typ podpisu. Např. u XML typ umístění podepsaných dat Detached, Enveloped, Enveloping, ...
     */
    signatureType: string; // "Detached" | "Enveloping" | "Enveloped"; // https://msdn.microsoft.com/en-us/library/ms761350(v=vs.85).aspx
}
